import React from 'react';
import { useTheme } from '@planne-software/uni/mui/material';
import { IconTrendingUp } from '@tabler/icons-react';
import { useTranslate, useWidgetParam } from '@src/core/hooks';
import { useTrendingReservations } from './useTrendingReservations';
import { Container, Label } from './styles';

const TrendingReservations = () => {
  const productId = useWidgetParam('product-id');
  const { i18n } = useTranslate();
  const theme = useTheme();
  const count = useTrendingReservations(productId);

  if (count === null) return null;

  return (
    <Container>
      <IconTrendingUp size={20} color={theme.tokens.colors['icon-color-accent-base']} />
      <Label>{i18n('product_booking_trending_reservations', { count })}</Label>
    </Container>
  );
};

export default TrendingReservations;
